import { createContext, createElement, useContext } from 'react';
import { ImageWithLoader } from './ImageLoading';
const PlainImage = (props) => createElement(ImageWithLoader, props);
const EvidenceImageContext = createContext(PlainImage);
export const EvidenceImageProvider = EvidenceImageContext.Provider;
export function EvidenceImage(props) {
    const Image = useContext(EvidenceImageContext);
    return createElement(Image, props);
}
/** The base the server stamps on every stored upload (lib/storedImageBaseUrl.ts). */
const STORED_UPLOADS_PREFIX = 'https://api.overlayqa.com/uploads/';
/** Swap the production host for `apiOrigin` on our own upload URLs; a no-op on production and for anything else. */
export function resolveStoredEvidenceUrl(url, apiOrigin) {
    const origin = apiOrigin.replace(/\/+$/, '');
    if (origin === 'https://api.overlayqa.com' || !url.startsWith(STORED_UPLOADS_PREFIX))
        return url;
    return `${origin}${url.slice('https://api.overlayqa.com'.length)}`;
}
//# sourceMappingURL=EvidenceImage.js.map